import styled, { keyframes } from 'styled-components';

const tickerAnimation = keyframes`
  0% {
    transform: translateY(25%);
  }
  100% {
    transform: translateY(-100%);
  }
`;

export const TickerContainer = styled.div`
  width: 100%;
  align-items: start;
  display: grid;

  > * {
    grid-column-start: 1;
    grid-row-start: 1;
  }
`

export const TickerWrapper = styled.div`
  background: transparent;
  width: 40%;
  height: 33%; /* Adjust as needed */
  overflow: hidden;
  top: 23%;
  justify-self: center;
  position: relative;
`;

export const TickerInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 20px 40px;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  animation: ${tickerAnimation} 60s linear infinite;

  @media (max-width: 1540px) {
    padding: 10px 20px;
    gap: 10px;
  }
`;

export const WhiteHeading = styled.p`
  color: white;
  font-size: 70px;
  line-height: 0.6;
  font-family: "BebasNeue";
  font-weight: bold;
  display: inline-block;
  white-space: nowrap;
  margin: 0px;
  margin-top: 20px;

  @media (max-width: 3300px) {
    font-size: 8.4rem;
  }

  @media (max-width: 2875px) {
      font-size: 7.5rem;
  }

  @media (max-width: 2600px) {
    font-size: 7rem;
    margin-top: 15px;
  }

  @media (max-width: 2385px) {
    font-size: 6.4rem;
  }

  @media (max-width: 2150px) {
    font-size: 5.6rem;
  }

  @media (max-width: 1940px) {
    font-size: 5rem;
  }

  @media (max-width: 1780px) {
      font-size: 4.3rem;
      margin-top: 10px;
  }

  @media (max-width: 1540px) {
    font-size: 3.55rem;
  }

  @media (max-width: 1280px) {
      font-size: 3rem;
  }

  @media (max-width: 1080px) {
    font-size: 2.53rem;
    margin-top: 5px;
  }

  @media (max-width: 960px) {
    font-size: 2.15rem;    
    margin-top: 0px;
  }

  @media (max-width: 840px) {
    font-size: 1.8rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1.7rem;
  }
`

export const YellowHeading = styled.p`
  color: ${({theme}) => theme.mintYellowHeading};  
  line-height: 0.75;
  font-family: "NeueMachina";
  font-weight: bold;
  display: inline-block;
  white-space: normal;
  margin: 0;

  @media (max-width: 3300px) {
    font-size: 9rem;
  }

  @media (max-width: 2875px) {
      font-size: 8rem;
  }

  @media (max-width: 2600px) {
    font-size: 7.5rem;
  }

  @media (max-width: 2385px) {
    font-size: 6.8rem;
  }

  @media (max-width: 2150px) {
    font-size: 6rem;
  }

  @media (max-width: 1940px) {
    font-size: 5.3rem;
  }

  @media (max-width: 1780px) {
      font-size: 4.6rem;
  }

  @media (max-width: 1540px) {
    font-size: 3.8rem;
}

  @media (max-width: 1280px) {
      font-size: 3.2rem;
  }

  @media (max-width: 1080px) {
    font-size: 2.7rem;
  }

  @media (max-width: 960px) {
    font-size: 2.3rem;
  }

  @media (max-width: 840px) {
    font-size: 1.9rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 1.7rem;
  }
`

export const TickerSeparator = styled.div`
  height: 2px;
  width: 100%;
  background: transparent;
  border: 0;
  margin: 0;
`

export const BoldParagraph = styled.p`
  color: white;  
  font-family: "NeueMachina";
  font-weight: bold;
  font-size: 24px;
  line-height: 1.1;
  margin: 0;

  @media (max-width: 3300px) {
    font-size: 2.9rem;
  }

  @media (max-width: 2875px) {
      font-size: 2.4rem;
  }

  @media (max-width: 2600px) {
    font-size: 2.1rem;
  }

  @media (max-width: 2385px) {
    font-size: 1.9rem;
  }

  @media (max-width: 2150px) {
    font-size: 1.7rem;
  }

  @media (max-width: 1940px) {
    font-size: 1.52rem;
  }

  @media (max-width: 1780px) {
      font-size: 1.33rem;
  }

  @media (max-width: 1540px) {
    font-size: 1.15rem;
}

  @media (max-width: 1280px) {
      font-size: 1rem;
  }

  @media (max-width: 1080px) {
    font-size: 0.85rem;
  }

  @media (max-width: 960px) {
    font-size: 0.7rem;
  }

  @media (max-width: 840px) {
    font-size: 0.58rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 0.5rem;
  }
`

export const RegularParagraph = styled.p`
  color: white;  
  font-family: "NeueMachina";
  font-weight: normal;
  font-size: 24px;
  line-height: 1.1;
  margin: 0;

  @media (max-width: 3300px) {
    font-size: 2.9rem;
  }

  @media (max-width: 2875px) {
      font-size: 2.4rem;
  }

  @media (max-width: 2600px) {
    font-size: 2.1rem;
  }

  @media (max-width: 2385px) {
    font-size: 1.9rem;
  }

  @media (max-width: 2150px) {
    font-size: 1.7rem;
  }

  @media (max-width: 1940px) {
    font-size: 1.52rem;
  }

  @media (max-width: 1780px) {
      font-size: 1.33rem;
  }

  @media (max-width: 1540px) {
    font-size: 1.15rem;
}

  @media (max-width: 1280px) {
      font-size: 1rem;
  }

  @media (max-width: 1080px) {
    font-size: 0.85rem;
  }

  @media (max-width: 960px) {
    font-size: 0.7rem;
  }

  @media (max-width: 840px) {
    font-size: 0.58rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 0.5rem;
  }
`

export const FooterParagraph = styled.p`
  color: white;  
  font-family: "NeueMachina";
  font-weight: bold;
  font-size: 28px;
  line-height: 1.3;
  margin: 0;

  @media (max-width: 3300px) {
    font-size: 3.3rem;
  }

  @media (max-width: 2875px) {
      font-size: 2.8rem;
  }

  @media (max-width: 2600px) {
    font-size: 2.5rem;
  }

  @media (max-width: 2385px) {
    font-size: 2.3rem;
  }

  @media (max-width: 2150px) {
    font-size: 2.1rem;
  }

  @media (max-width: 1940px) {
    font-size: 1.92rem;
  }

  @media (max-width: 1780px) {
      font-size: 1.73rem;
  }

  @media (max-width: 1540px) {
    font-size: 1.5rem;
}

  @media (max-width: 1360px) {
      font-size: 1.3rem;
  }

  @media (max-width: 1220px) {
    font-size: 1.1rem;
  }

  @media (max-width: 1070px) {
    font-size: 0.9rem;
  }

  @media (max-width: 920px) {
    font-size: 0.72rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 0.65rem;
  }
`
